import React from 'react';
import '../styles.css';
import { CheckIcon, XIcon } from '../icons/navigationIcons';

/* Body copy uses .text-body-sm — see styles.css */

const IterationStatus = ({ items }) => {
    return (
        <div className="text-body-sm" style={styles.root}>
            {items.map((item, index) => (
                <div key={index} style={styles.row}>
                    <div style={styles.iconContainer}>
                        {item.type === 'success' ? <CheckIcon /> : <XIcon />}
                    </div>
                    <div style={styles.textContainer}>{item.text}</div>
                </div>
            ))}
        </div>
    );
};

const styles = {
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        alignSelf: 'stretch',
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        paddingLeft: '20px',
        gap: '15px',
    },
    row: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '20px',
        alignSelf: 'stretch',
    },
    iconContainer: {
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        minWidth: '20px',
        minHeight: '32px',
    },
    textContainer: {
        flex: 1,
        minWidth: 0,
    },
};

export default IterationStatus;
